import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY

/** Surfaced by the app rather than thrown, so a missing .env.local reads as a
 *  setup step and not as a crash. */
export const configured = Boolean(url && anon)

// Deliberately untyped. A hand-written Database type cannot satisfy
// postgrest-js's internal generic — the package ships no readable
// declarations to match — and every table silently resolves to `never`.
// Run `supabase gen types typescript --linked > src/lib/database.types.ts`
// once the project is linked, then restore the generic. Until then the domain
// types in types.ts carry the shapes the app actually handles.
export const supabase = createClient(url ?? 'http://unconfigured', anon ?? 'unconfigured', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // Passkeys are experimental and must be opted into explicitly. They are
    // bound to the Relying Party ID set in the dashboard, which is the bare
    // domain — so they work in production and not on localhost, where password
    // sign-in is the fallback.
    experimental: { passkey: true },
  },
})
